
import React from 'react';
import PropTypes from 'prop-types';

import { Input, Select } from 'antd';


const FormControl = (props) => {
  const {
    label,
    FieldComponent,
    error,
    ...extraProps
  } = props;

  return (
    <div style={{ padding: '0 6px', marginBottom: '12px' }}>
      {label && <span>{label}</span>}
      <FieldComponent {...extraProps} style={{ width: '100%' }} />
      {error && <FieldErrorMessage errorMessage={error} />}
    </div>
  );
};

FormControl.defaultProps = {
  FieldComponent: Input,
  label: null,
  error: '',
};

FormControl.propTypes = {
  label: PropTypes.any,
  FieldComponent: PropTypes.any,
  error: PropTypes.string,
};

export default FormControl;

// =================== =================== =================== =================== ===================
const FormControlSelect = (props) => {
  const {
    label,
    options,
    error,
    ...extraProps
  } = props;

  return (
    <div style={{ padding: '0 6px', marginBottom: '12px' }}>
      {label && <span>{label}</span>}
      <Select {...extraProps} style={{ width: '100%' }}>
        {options.map((optionData) => (
          <Select.Option key={optionData.value} value={optionData.value}>{optionData.label}</Select.Option>
        ))}
      </Select>
      {error && <FieldErrorMessage errorMessage={error} />}
    </div>
  );
};

FormControlSelect.defaultProps = {
  label: null,
  options: [],
  error: '',
};

FormControlSelect.propTypes = {
  label: PropTypes.any,
  options: PropTypes.array,
  error: PropTypes.string,
};

// =================== =================== =================== =================== ===================
const FieldErrorMessage = ({ errorMessage, ...extraProps }) => (
  <p style={{ color: 'red', fontSize: '14px' }} {...extraProps}>
    {errorMessage}
  </p>
);

FieldErrorMessage.propTypes = {
  errorMessage: PropTypes.string.isRequired,
};

// =================== =================== =================== =================== ===================
export {
  FormControlSelect as Select,
  FieldErrorMessage,
};
